<template>
  <div 
    style="max-width: 500px; position: relative; height:100%; overflow: hidden;" 
    class="Kanit mx-auto bg-home">
    <!-- Content Box -->
    <!-- <div style="max-height: calc(100vh - 120px); overflow-y: auto; margin: 12px;">  -->
    <div class="wrapper-content-box"> 
      <div class="content-box text-left">
        <p style="font-size: 20px; font-weight: 700;" class="primary--text text-center">นโยบายความเป็นส่วนตัว<p>
        <p>นโยบายความเป็นส่วนตัวออนไลน์นี้ได้รับการปรับปรุงล่าสุดในเดือนกุมภาพันธ์ 2564 เรายึดมั่นเคารพความเป็นส่วนตัวและสิทธิในการตัดสินใจด้วยตนเองของคุณ เหตุผลดังนี้ยังใช้กับการจัดการข้อมูลส่วนบุคคลเมื่อคุณเยี่ยมชมและใช้เว็บไซต์นี้ ด้วยเหตุนี้เราจึงดำเนินการเพื่อให้เป็นไปตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลที่บังคับใช้ ในขณะที่เรายังคงมุ่งพัฒนาที่จะนำผลิตภัณฑ์มาสู่ออนไลน์ เรายังจะทำให้เทคโนโลยีที่ทันสมัยนี้สอดคล้องไปกับการคุ้มครองความเป็นส่วนตัวของคุณ</p>
        <p style="font-size: 20px; font-weight: 700;" class="primary--text text-center">หลักความเป็นส่วนตัวของเรา<p>
        <div style="font-weight: 700;">ความโปร่งใส</div>
        <div>เราต้องการให้คุณทราบถึงข้อมูล และวิธีการเก็บข้อมูลที่เราได้/จัดเก็บ/รวบรวมระหว่าง ที่คุณกำลังเยี่ยมชมเว็บไซต์ของเรา</div>
        <div style="font-weight: 700;">ทางเลือก</div>
        <div>เราจะเสนอทางเลือกเกี่ยวกับข้อมูลที่เราและคู่ค้าที่เราไว้ใจจะนำไปใช้ได้</div>
        <div style="font-weight: 700;">ความถูกต้องของข้อมูล</div>
        <div>เราจะรับผิดชอบต่อการดูแลปกป้องข้อมูลเกี่ยวกับคุณที่เราเก็บจากเว็บไซต์ผ่านเทคโนโลยีที่ปลอดภัยเชื่อถือได้</div>
        <p style="font-size: 20px; font-weight: 700;" class="primary--text text-center mt-6">ข้อมูลที่ถูกเก็บ<p>
        <div style="font-weight: 700;">ข้อมูลใดบ้างที่เราเก็บ</div>
        <div>ข้อมูลส่วนตัวที่ระบุตัวตนได้ (“พีไอไอ”) ข้อมูลใดๆที่สามารถใช้เพื่อระบุตัวตนของคุณจะถูกพิจารณาเป็นข้อมูลส่วนตัวที่ระบุตัวตนได้ หรือ พีไอไอ ข้อมูลนี้รวมถึงแต่ไม่จัดเพียงแค่ชื่อ ที่อยู่ อีเมล เบอร์โทรศัพท์ เบอร์แฟกซ์ และข้อมูลบัตรเครดิต</div>
        <div style="font-weight: 700;">ข้อมูลการเรียกดู</div>
        <div>ข้อมูลที่เก็บจากกิจกรรมต่าง ๆ บนเว็บไซต์ผ่านเทคโนโลยี อาทิเช่น คุ๊กกี้และบีคอน หมายถึงข้อมูลการเรียกดู ข้อมูลการเรียกดูนี้เชื่อมต่อกับไอพีที่ไม่ระบุตัวตน ไม่ได้เชื่อมต่อถึงคุณโดยเฉพาะ ข้อมูลเหล่านี้คือพีไอไอ</div>
        <div style="font-weight: 700;">ข้อมูลที่คุณโพสต์</div>
        <div>ข้อมูลทั้งหมดที่คุณให้เกี่ยวกับตัวคุณ ไม่ว่าจะเป็นพีไอไอหรือไม่ ในส่วนที่เป็นสาธารณะของโซเชียลเน็ตเวิร์ค ในส่วนเนื้อหาที่สร้างโดยผู้ใช้บนเว็บไซต์ของเรา และอื่นๆ ถือเป็นข้อมูลสาธารณะ เพราะฉะนั้นหากคุณไม่ต้องการให้เปิดเผย กรุณาไม่โพสต์ข้อมูลเหล่านั้น</div>
        <div style="font-weight: 700;">ใครเป็นผู้เก็บข้อมูล</div>
        <div>เราเป็นผู้เก็บข้อมูลจากคุณเมื่อคุณใช้งานเว็บไซต์นี้ เราอาจเก็บข้อมูลที่เกี่ยวกับคุณผ่านบุคคลที่สาม คู่ค้าทางธุรกิจที่เราไว้ใจอาจเก็บข้อมูลจากคุณเช่นกัน เพื่อประโยชน์ต่อการดูแลพัฒนาเว็บไซต์และให้บริการที่ตรงต่อความสนใจของคุณ “เรา” ในที่นี้จึงอาจหมายรวมถึงคู่ค้าทางธุรกิจที่เราไว้ใจด้วย</div>

        <div>
          <v-row>
            <v-col cols="1" class="text-center">
              <v-checkbox
                v-model="cbagree"
              ></v-checkbox>
            </v-col>
            <v-col cols="11" class="text-left">
              <p style="padding-top: 16px">
                ฉันยินยอมให้บริษัทใช้ข้อมูลส่วนบุคคลของฉันเพื่อเปิดเผยในการรับข้อมูลผลิตภัณฑ์ ข้อเสนอพิเศษ และการบริการจาก LAMY รวมทั้งเปิดเผยให้กับบริษัทในเครือ  และ LAMY เพื่ออำนวยประโยชน์การให้บริการต่อไป</p>
              <p>I hereby give my consent to the company to process my personal data for any other products  information,  promotions and services  offered from LAMY and its  affiliates as well as for further services improvement</p>
            </v-col>
          </v-row>
        </div>        
      </div>
    </div>
    <!-- </div> -->
    <!-- Button -->
    <div class="container">
      <v-row>
        <v-col cols="5">
          <v-btn
            tile
            dark
            color="#CCC"
            style="width: 100%; height: 48px;"
            @click="changePage('home')"
          >
            ยกเลิก
          </v-btn>
        </v-col>
        <v-col cols="7">
          <v-btn
            :loading="saveloading"
            tile
            dark
            color="#000"
            style="width: 100%;  height: 48px;"
            @click="agree(cbagree)"
          >
            สมัครสมาชิก
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Header.vue";

export default {
  data() {
    return {
      cbagree: false,
      saveloading: false,
    };
  },
  components: {
    Header
  },  
  methods: {
    agree(val) {
      var data = {
        userid: this.$store.state.userid,
        // pageid: this.query.pageid,
        pageid: this.$store.state.pageid,
        pdpa: val
      };
      this.saveloading = true;
      axios
        .post(this.serverUrl + "lamy/pdpa", data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        })
        .then(async (response) => {
          if (response.data.responsecode == 200) {
    
              this.changePage('register');
              this.saveloading = false;
              // this.sendMessage("สั่งซื้อวัตถุดิบ");
              // this.$emit("close");
          } else {
            await this.$swal.fire({
              text: response.data.reason,
              confirmButtonColor: '#000'
            });
          }
          
        });
    },
    changePage(name) {
      var path = "/"+name;
      if (this.$route.path !== path) {
        this.$router.push({
          path: name,
          query: {...this.$route.query } ,
        }).catch({});
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>